import React from 'react';
import {
  Box,
  Container,
  Grid,
  Typography,
  Link,
  Button,
  IconButton,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import XIcon from '@mui/icons-material/X';

interface FooterItem {
  text: string;
  link: string;
  internal: boolean;
}

interface FooterSection {
  title: string;
  items: FooterItem[];
}

const Footer = () => {
  const calendlyLink = "https://calendly.com/fambercontact/30min";

  const sections: FooterSection[] = [
    {
      title: 'Produits',
      items: [
        { text: 'Agents IA', link: '/agents', internal: true },
        { text: 'Tarifs', link: '/pricing', internal: true },
        // { text: 'Fonctionnalités', link: calendlyLink, internal: false },
        { text: 'Intégrations', link: '/case-studies', internal: true },
      ],
    },
    // {
    //   title: 'Ressources',
    //   items: [
    //     { text: 'Documentation', link: calendlyLink },
    //     { text: 'API', link: calendlyLink },
    //     { text: 'Blog', link: calendlyLink },
    //     { text: 'Tutoriels', link: calendlyLink },
    //   ],
    // },
    {
      title: 'Support',
      items: [
        // { text: 'Centre d\'aide', link: calendlyLink },
        // { text: 'FAQ', link: calendlyLink },
        { text: 'Contact', link: calendlyLink, internal: false },
        // { text: 'Statut', link: calendlyLink },
      ],
    },
    {
      title: 'Légal',
      items: [
        // { text: 'Confidentialité', link: calendlyLink },
        { text: 'Conditions d\'utilisation', link: calendlyLink, internal: false },
        // { text: 'Cookies', link: calendlyLink },
        // { text: 'RGPD', link: calendlyLink },
      ],
    },
  ];

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: 'rgba(250, 248, 245, 0.95)',
        py: 8,
        mt: 'auto',
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={4}>
          <Grid item xs={12} md={4}>
            <Box sx={{ mb: 4 }}>
              <Box
                component="img"
                src="/logo_2.png"
                alt="Famber Logo"
                sx={{ height: 40, mb: 2 }}
              />
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                La marketplace révolutionnaire pour les agents IA. Découvrez, utilisez et partagez des agents IA intelligents.
              </Typography>
              <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                <IconButton
                  component="a"
                  href="https://x.com/famberai"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: '#8B5CF6' }}
                >
                  <XIcon />
                </IconButton>
                <IconButton
                  component="a"
                  href="https://www.linkedin.com/company/famberai/"
                  target="_blank"
                  rel="noopener noreferrer"
                  sx={{ color: '#8B5CF6' }}
                >
                  <LinkedInIcon />
                </IconButton>
              </Box>
              <Button
                variant="contained"
                component="a"
                href={calendlyLink}
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  backgroundColor: '#8B5CF6',
                  color: '#ffffff',
                  '&:hover': {
                    backgroundColor: '#7C3AED',
                  },
                }}
              >
                Commencer
              </Button>
            </Box>
          </Grid>
          {sections.map((section) => (
            <Grid item xs={6} sm={4} md={2} key={section.title}>
              <Typography variant="h6" color="text.primary" gutterBottom>
                {section.title}
              </Typography>
              {section.items.map((item) => (
                <Link
                  key={item.text}
                  component={item.internal ? RouterLink : 'a'}
                  to={item.internal ? item.link : undefined}
                  href={!item.internal ? item.link : undefined}
                  target={!item.internal ? "_blank" : undefined}
                  rel={!item.internal ? "noopener noreferrer" : undefined}
                  sx={{
                    display: 'block',
                    color: 'text.secondary',
                    textDecoration: 'none',
                    mb: 1,
                    '&:hover': {
                      color: '#8B5CF6',
                    },
                  }}
                >
                  {item.text}
                </Link>
              ))}
            </Grid>
          ))}
        </Grid>
        <Box
          sx={{
            mt: 8,
            pt: 4,
            borderTop: '1px solid',
            borderColor: 'divider',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 2,
          }}
        >
          <Typography variant="body2" color="text.secondary">
            © {new Date().getFullYear()} Famber. Tous droits réservés.
          </Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Link
              component="a"
              href={calendlyLink}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'text.secondary',
                textDecoration: 'none',
                '&:hover': {
                  color: '#8B5CF6',
                },
              }}
            >
              Mentions légales
            </Link>
            <Link
              component="a"
              href={calendlyLink}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: 'text.secondary',
                textDecoration: 'none',
                '&:hover': {
                  color: '#8B5CF6',
                },
              }}
            >
              Politique de confidentialité
            </Link>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer; 